import { InputsHeader } from '../InputsHeader';
import { NumericInput } from '../form-controls';
import { Grid } from '../layout';

export function Sulfur() {
  return (
    <>
      <InputsHeader title="Sulfur" subtitle="Input Values" />
      <Grid columns={2} columnSpacing={{ xs: 2, sm: 3 }}>
        <NumericInput
          name="starterFertilizer.sulfur.preplant"
          label="Preplant"
        />
        <NumericInput
          name="starterFertilizer.sulfur.mar1V2"
          label="Mar 1 - V2"
        />
      </Grid>
    </>
  );
}
